/** The unit emissions are stated in, as a person reads it.
 *
 * Amounts cross the wire in kilograms of CO2e and are shown in metric tonnes (`format.tonnes`
 * divides once, in the presentation layer). The label lives here so a screen that prints a figure
 * does not retype it, and so the one place that would change if a market asked for another word
 * (a short ton is not a metric tonne, and no screen may use the word interchangeably) is this one.
 */
export const EMISSIONS_UNIT = "tCO₂e";
